define([
    'text!product-detail/furniture/material-list-new.html',
    'product-detail/mixin/product',
    'product-detail/component/material-list',
    'inView',

    'css!product-detail/furniture/material-list-new.css'
], function(
    tpl,
    ProductMixin,
    MateriList,
    inView
){
    /*var animateConfig = [
        {index: 1, attr: 'right', from: '-100px', to: '446px'},
        {index: 2, attr: 'left', from: '0', to: '391px'},
        {index: 3, attr: 'bottom', from: '0', to: '213px'},
        {index: 4, attr: 'right', from: '-124px', to: '338px'},
        {index: 5, attr: 'left', from: '-61px', to: '440px'},
        {index: 6, attr: 'bottom', from: '-146px', to: '301px'},
        {index: 7, attr: 'left', from: '-147px', to: '360px'}
    ];*/

    return {
        template: tpl,
        components: {
            MateriList: MateriList
        },
        mixins: [ProductMixin],
        data: function(){
            return {
                className: 'js-material-list',
                isEnter: false,
                activeMaterial: null,
                isAnimateEnd: false
            };
        },
        computed: {
            materials: function(){
                return this.spuExtraBase.materialData || [];
            },
            isPC: function () {
                if($(window).width()<=750){
                    $('.fixed-menu').css({display: 'none'});
                    return false;
                }else {
                    return true;
                }
            }
        },
        methods: {
            getMatClass: function(index){
                if(this.isPC){
                    var classNames =  ['m-mat-'+(index+1)];
                }else {
                    var classNames =  ['m-mat-phone-'+(index+1)];
                }
                if (!this.isEnter) {
                    classNames.push('before-animate');
                }
                return classNames;
            }
        },
        mounted: function(){
            var _this = this;
            var task = null;
            var delayTime = 500;
            var duration = 2000;
            inView('.'+this.className).on('enter', function(){
                task = setTimeout(function(){
                    _this.isEnter = true;
                    task = setTimeout(function(){
                        _this.isAnimateEnd = true;
                        task = null;
                    }, duration);
                },delayTime);
            }).on('exit', function(){
                if (task){
                    clearTimeout(task);
                    task = null;
                }
                _this.isEnter = false;
                _this.isAnimateEnd = false;
            });
            $(window).resize( function  () {           //当浏览器大小变化时
                if(($(window).width()<=750&&_this.isPC)||($(window).width()>750&&!_this.isPC)){
                    window.location.reload();
                }
            });
        }
    };
});


//////////////////
// WEBPACK FOOTER
// ./product-detail/furniture/material-list-new.js
// module id = 319
// module chunks = 0